import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CanActivateViaAuthGuard } from '../../shared/services/auth.service'
import { MyDatePickerModule } from 'mydatepicker';
import { BsModalModule } from 'ng2-bs3-modal';
import { PrincipalService } from '../../shared';
import { SupportRoutingModule } from './support-routing.module';
import { SupportAppConfigComponent } from './components/appconfig/app-config.component';
import { SupportService } from './services/support.service';
import { AppConfigResourceApi } from '../../shared/services/api/app-config-resource.api';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),
    MyDatePickerModule,
    BsModalModule,
    ReactiveFormsModule,
    SupportRoutingModule,
    TranslateModule.forChild()
  ],
  declarations: [SupportAppConfigComponent],
  exports:[FormsModule,ReactiveFormsModule],
  providers:[
    CanActivateViaAuthGuard,
    PrincipalService,
    SupportService,
    AppConfigResourceApi
  ]
})
export class SupportModule { }
